export default function (app) {

    app.controller('KtsGoldController', ['$scope', 'Restangular', 'Auth','$location', 
        function ($scope, Restangular, Auth,$location) {
            
            Restangular.one('gold/types').get().then(function (t) {
                $scope.types = t.types;
            });
                
            this.add = function (type, codes, email) {
                if (!type) {
                    alert('Deve seleccionar um tipo');
                    return;
                }
                
                Restangular.one('gold').customPOST({
                    products: codes.split(" "),
                    type: type,
                    user: !!email ? email : -1
                }).then(function (user) {
                    alert("E-mails enviados");
                }, function (response) {
                    alert("Ocurreu um erro, por favor contactar o luis");
                });
            };

        }]);
    
}





// WEBPACK FOOTER //
// ./js/pages/gold/index.js